import { render, staticRenderFns } from "./Planillas.vue?vue&type=template&id=4ae21dff&scoped=true&"
import script from "./Planillas.vue?vue&type=script&lang=js&"
export * from "./Planillas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae21dff",
  null
  
)

export default component.exports